import { render, staticRenderFns } from "./Final.vue?vue&type=template&id=0d2fe203&scoped=true&"
import script from "./Final.vue?vue&type=script&lang=js&"
export * from "./Final.vue?vue&type=script&lang=js&"
import style0 from "./Final.vue?vue&type=style&index=0&id=0d2fe203&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2fe203",
  null
  
)

export default component.exports